import { useGoBack } from '../lib/useGoBack';

/**
 * The header of a page of words (the terms, the privacy policy, the FAQs): a
 * Back to wherever the reader came from (`useGoBack`), and the page's title.
 */
export default function LegalTop({ title, fallback = '/', titleStyle = undefined }) {
  const goBack = useGoBack(fallback);

  return (
    <header className="legal-top">
      <button type="button" className="legal-back" aria-label="Back" onClick={goBack}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M15.5 18.5L8.5 12l7-7.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <h1 className="legal-top__title" style={titleStyle}>
        {title}
      </h1>
      <span className="legal-top__spacer" aria-hidden />
    </header>
  );
}
